/*
* DialogPlayerContentEvent.js
* Created on 9-3-2021
* @author reinier@ranj.nl
*/

import NGTDialogPlayer from "../NGTDialogPlayer";

export default class DialogPlayerRegisterEvent {
    /**
     * @param {String} type 
     * @param {NGTDialogPlayer} dialogPlayer 
     */
    constructor(type, dialogPlayer) {
        this.type = type;
        this.dialogPlayer = dialogPlayer;
    }
}

DialogPlayerRegisterEvent.REGISTER = "DialogPlayerRegisterEvent.REGISTER";
DialogPlayerRegisterEvent.DEREGISTER = "DialogPlayerRegisterEvent.DEREGISTER";